import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getPublicReviews } from "@/lib/reviews.functions";
import { REVIEW_STATS } from "@/data/reviews";

type Bron = { naam: string; score: number; schaal: number; aantal: number; url: string };

/**
 * Actuele reviewcijfers (automatisch gesynchroniseerd met Homedeal en Google).
 * Tot de live cijfers binnen zijn, of als die ontbreken, gelden de cijfers
 * uit src/data/reviews.ts als terugval.
 */
export function useReviewStats() {
  const fetchPublicReviews = useServerFn(getPublicReviews);
  const { data: live } = useQuery({
    queryKey: ["homedeal-reviews"],
    queryFn: () => fetchPublicReviews(),
    staleTime: 4 * 60 * 60 * 1000,
    retry: 1,
  });

  const [hdFallback, gFallback] = REVIEW_STATS.bronnen;
  const bronnen: Bron[] = [
    live?.homedeal
      ? { ...hdFallback, score: Math.round(live.homedeal.avgRating * 10) / 10, aantal: live.homedeal.reviewCount }
      : { ...hdFallback },
    live?.google
      ? { ...gFallback, score: Math.round(live.google.avgRating * 10) / 10, aantal: live.google.reviewCount }
      : { ...gFallback },
  ];

  const totaal = {
    score: live?.avgRating ?? REVIEW_STATS.totaal.score,
    schaal: REVIEW_STATS.totaal.schaal,
    aantal: live?.reviewCount ?? REVIEW_STATS.totaal.aantal,
  };

  const bijgewerkt = live?.syncedAt
    ? new Date(live.syncedAt).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" })
    : REVIEW_STATS.bijgewerkt;

  return { totaal, bronnen, bijgewerkt };
}
